import React from 'react';
import classNames from 'classnames';

import styles from './Card.module.scss';

export interface CardPropsI {
  children: React.ReactNode;
  variant?: 'danger' | '';
  height?: string;
  width?: string;
  padding?: string;
  margin?: string;
  className?: string;
}

const Card = (props: CardPropsI): JSX.Element => {
  const cardClasses = classNames(styles.Card, {
    [`${props.className}`]: props.className,
    [styles.Card__danger]: props.variant === 'danger'
  });

  const cardOverlayClasses = classNames(styles.Card__overlay, {
    [styles.Card__overlay_danger]: props.variant === 'danger'
  });

  const style = {
    width: props.width,
    height: props.height,
    padding: props.padding ? props.padding : '0',
    margin: props.margin ? props.margin : '0'
  };

  return (
    <div className={cardClasses} style={style}>
      <div className={cardOverlayClasses}></div>
      {props.children}
    </div>
  );
};

export interface CardHeaderPropsI {
  children: React.ReactNode;
  margin?: string;
}

const CardHeader = ({ children, margin }: CardHeaderPropsI): JSX.Element => {
  return (
    <div className={styles.Card__header} style={{ margin: margin && margin }}>
      {children}
    </div>
  );
};

const CardTitle = ({ children }: { children: React.ReactNode }): JSX.Element => {
  return <div className={styles.Card__title}>{children}</div>;
};

export interface CardButtonPropsI {
  children: React.ReactNode;
  onClick: () => void;
  open?: boolean;
}

const CardButton = (props: CardButtonPropsI): JSX.Element => {
  const buttonClasses = classNames(styles.Card__button, {
    [styles.Card__button_open]: props.open,
    [styles.Card__button_close]: props.open !== undefined && !props.open
  });

  return (
    <div className={buttonClasses} onClick={() => props.onClick()}>
      {props.children}
    </div>
  );
};

Card.Header = CardHeader;
Card.Title = CardTitle;
Card.Button = CardButton;

export default Card;
